/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListScopes } from "../funcs/accessListScopes.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListScopesResult } from "../models/components/listscopesresult.js";
import {
  ListScopesRequest,
  ListScopesSecurity,
} from "../models/operations/listscopes.js";
import { unwrapAsync } from "../types/fp.js";
export type ListScopesQueryData = ListScopesResult;

export function prefetchListScopes(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListScopesRequest | undefined,
  security?: ListScopesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListScopesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListScopesQuery(
  client$: GramCore,
  request?: ListScopesRequest | undefined,
  security?: ListScopesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListScopesQueryData>;
} {
  return {
    queryKey: queryKeyListScopes({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function listScopesQueryFn(
      ctx,
    ): Promise<ListScopesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListScopes(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListScopes(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listScopes", parameters];
}
